export default __webpack_public_path__ + "static/media/512.d5ac3d83.png";